fragment SectionHeadingFragment on sectionHeading_Entry {
  typeHandle
  tagLine
  heading
  teaserText
  showScrolldown
}
